var React = require('react');

function Crop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 376v48a24 24 0 0 1-24 24h-40v-96h40a24 24 0 0 1 24 24zM416 64a32 32 0 0 1 32 32v13.25l59.31-59.31a16 16 0 0 0 0-22.63L484.69 4.69a16 16 0 0 0-22.63 0L402.75 64zm-64 141.25V160h-45.25L160 306.75V24a24 24 0 0 0-24-24H88a24 24 0 0 0-24 24v392a32 32 0 0 0 32 32h224v-96H205.25z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 64H192v96h160v328a24 24 0 0 0 24 24h48a24 24 0 0 0 24-24V96a32 32 0 0 0-32-32zM0 88v48a24 24 0 0 0 24 24h40V64H24A24 24 0 0 0 0 88z","className":"fa-primary","key":2})]);
}

Crop.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Crop;

Crop.default = Crop;
